// src/plugins/vuetify.js
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import 'vuetify/styles' // Vuetify stil dosyaları
import { createVuetify } from 'vuetify'
// import * as components from 'vuetify/components' // Tüm bileşenleri import etmek yerine
// import * as directives from 'vuetify/directives' // Ağaç sallama (tree shaking) için ayarlar yapılabilir

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  // components, // Yukarıdaki gibi import edildiğinde
  // directives,
  theme: {
    // defaultTheme: 'light' // veya 'dark'
  }
})
